import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable, BehaviorSubject } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { OfflineService } from './offline.service';
import * as md5 from 'md5';

const l = window.location,
	// ORIGIN = l.hostname,
	SPOKE = 'thebarber',
    ENDPOINT = environment.forceLive ? `https://api.datalynk.ca` : `${l.protocol}//${l.hostname.split('.').pop() === 'datalynk' ? 'api' : 'api.datalynk.ca'}`;

function defaultDateToJson(): string {
	return this.toISOString();
}
function customDateToJson(): string {
	return `${this.getFullYear()}/${this.getMonth()+1}/${this.getDate()} ${this.getHours()}:${this.getMinutes()}:${this.getSeconds()}`;
}


@Injectable({
  providedIn: 'root'
})
export class ApiService {

    offline = new BehaviorSubject(false);
    endpoint = ENDPOINT;
    spoke = SPOKE;

	constructor(
		private _http: HttpClient,
		private _offline: OfflineService,
	) {
	}

	private _token: string;
	get token() {
		return this._token || localStorage.getItem(this.getTokenKey());
	}
	set token(token: string) {
		const key = this.getTokenKey();
		if (token !== this._token) {
			if (token) {
				localStorage.setItem(key, token);
			} else {
				localStorage.removeItem(key);
			}
			this._token = token;
		}
	}

	getTokenKey() {
		return `authorization-${ENDPOINT}`;
	}

	request<T>(payload: any, cache: string = '', extra?: Object): Observable<T> {
		// const send = this._encode(JSON.parse(JSON.stringify(payload))); // encode a clone
        // const send = this._encode(payload);
		const req = this._encode(payload);
        let fromCache = false;
        // headers
		return this
			._http
			.post(ENDPOINT, req, {
                withCredentials: false,
                headers: new HttpHeaders({
                    Authorization: `Bearer ${this.token}`,
                })
			})
			.pipe(
				catchError(err => {
					if (err.status === 401) {
						// at this point, its not caching, its a login issue
						// display the login box
						throw 'session_expired';
					}
					fromCache = true;
					if (!this.offline.getValue()) {
						this.offline.next(true);
					}
					if (cache) {
						return this._offline.get(cache);
					} else {
						return this._offline.getVolatile(md5(req))
					}
				}),
				map(resp => {
					if (!fromCache) {
						if (cache) {
							this._offline.save(cache, resp);
						} else {
							this._offline.saveVolatile(md5(req), resp);
						}
						if (this.offline.getValue()) {
							this.offline.next(false);
						}
					}
					return this._scan(resp)
				})
				// map(resp => this._decode(resp))
			);
	}

	/**
	 *
private _request<T>(obj: any, cache: string = '') {

		const payload = JSON.stringify(obj),
			params = new HttpParams()
				.set('spoke', this.spoke)
				.set('token', this.token)
				.set('socket', this.socketId)
				.set('cache', cache)
				.set('req', payload);

		let errored = false,
			fromCache = false;

		return this._http
			.post<ApiRequestResponse>(
				this.path,
				params,
				{
					withCredentials: false,
				}
			)
			.pipe(
				timeout(2000),
				catchError(
					err => {
						if (cache) {
							fromCache = true;
							return this._offline.get<ApiRequestResponse>(cache);
						} else {
							fromCache = true;
							return this._offline.getVolatile<ApiRequestResponse>(md5(payload));
						}
					}
				),
				map(resp => {
					if (!fromCache) {
						if (cache) {
							this._offline.save(cache, resp);
						} else {
							this._offline.saveVolatile(md5(payload), resp);
						}
					}
					if (resp.error && !fromCache) {
						console.log('fail', )
						this._throwError(resp);
					} else {
						return resp as T;
					}
				}),
			)
	}
	 */

	private _encode(v: any): string {
		Date.prototype.toJSON = customDateToJson;
		const ret = JSON.stringify(v);
		Date.prototype.toJSON = defaultDateToJson;
		return ret;
	}

	// private _decode<T>(v: any): T {
	// 	const ret: T = JSON.parse(v, (key, val) => {
	// 		if (val && val['$/tools/date']) {
	// 			return null;
	// 			// return new Date(val['$/tools/date']);
	// 		}
	// 		return val;
	// 	})
	// 	console.log('returns->', ret);
	// 	return ret;
	// }

	private _scan<T>(resp: any): T {
		const p = Object.prototype.toString.call(resp);
		if (p === '[object Object]') {
			if (resp['$/tools/date']) {
				resp = new Date(resp['$/tools/date'].replace(/-/g, "/"));

			} else {
				for (let k in resp) {
					resp[k] = this._scan(resp[k]);
				}
			}
		} else if (p === '[object Array]') {
			resp.map(r => this._scan(r))
		}
		return resp;
	}
}
